import Pikaday from "pikaday";
import 'moment/locale/ru';
import moment from "moment";

export function datepicker(dateField) {
  if (!dateField) return;
  let fieldType = dateField.value ? 'input' : 'div';
  new Pikaday({
    field: dateField,
    setDefaultDate: true,
    defaultDate: new Date(),
    minDate: new Date(),
    firstDay: 1,
    i18n: {
      previousMonth : 'Предыдущий месяц',
      nextMonth     : 'Следующий месяц',
      months: moment.localeData().months(),
      weekdays: moment.localeData()._weekdays,
      weekdaysShort: moment.localeData()._weekdaysShort
    },
    container: dateField.dataset.container&&document.querySelector(dateField.dataset.container),
    // format: moment(new Date).format('YYYY-MM-DD'),
    // onSelect: function(date) {
    //   dateField.value = moment(date).format('DD.MM.YYYY');
    // }
    onSelect: date => {
      const year = date.getFullYear(),
        month = date.getMonth() + 1,
        day = date.getDate(),
        formattedDate = [
          day < 10 ? '0' + day : day,
          month < 10 ? '0' + month : month,
          year
        ].join('.');
      if (fieldType === 'input') {
        dateField.value = formattedDate;
      } else {
        const hiddenInput = dateField.querySelector('input');
        hiddenInput.value = date;
        dateField.setAttribute('data-value', formattedDate);
        hiddenInput.dispatchEvent(new Event('change'));
      }
    }
  });
}
